module.exports = __webpack_public_path__ + "img/part5.87a21bd9.jpg";